import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

import 'react-dates/lib/css/_datepicker.css';

/**
* Class DateIntervalFilter
* Generic component to generate text filters
**/
class DateIntervalFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    moment.locale('fr');

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
    };
  }

  /**
  * render
  * Rendering component function : display the text filter
  **/
  render() {
    // Form rendering
    const filter =
      <Col componentClass="filterDateIntervalField" sm={2}>
        <DateRangePicker
          startDatePlaceholderText="Début"
          endDatePlaceholderText="Fin"
          isOutsideRange={() => false}
          startDate={this.state.startDate} // momentPropTypes.momentObj or null,
          startDateId="dateDebut" // PropTypes.string.isRequired,
          endDate={this.state.endDate} // momentPropTypes.momentObj or null,
          endDateId="dateFin" // PropTypes.string.isRequired,
          onDatesChange={this.handleChange.bind(this)} // PropTypes.func.isRequired,
          focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
          onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
        />
      </Col>;

    return filter;
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.setState({
      ...this.state,
      startDate: null,
      endDate: null,
    });
  }

  /**
  * handleChange
  * Handle value change
  **/
  handleChange({ startDate, endDate }) {
    startDate = startDate ? moment(startDate.format("DD/MM/YYYY"), "DD/MM/YYYY") : null;
    endDate = endDate ? moment(endDate.format("DD/MM/YYYY"), "DD/MM/YYYY") : null;

    this.setState({
      ...this.state,
      startDate: startDate,
      endDate: endDate,
    });
    this.props.parentFilter.handleDateIntervalChange(this, {startDate: startDate, endDate: endDate});
  }

}

export default DateIntervalFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/DateIntervalFilter.js